import axios from "./httpInterceptor";
import store from '@/store';
import i18n from '@/i18n';
import { createPublicReadCache, isPublicRead } from './publicReadCache';
import { trackPageRead } from './pageRequests';

const read = createPublicReadCache();
export default class HttpHandler {
    get(url, params = {}, config = {}) {
        return this.request('get', url, params, config);
    }
    post(url, data = {}, config = {}) {
        return this.request('post', url, data, config);
    }
    request(method, url, params, config) {
        const publicRead = isPublicRead(method, url, params);
        if (publicRead) params = JSON.parse(JSON.stringify(params));
        const options = publicRead ? { timeout: 15000, ...config } : config;
        const fetch = () => method === 'get'
            ? axios.get(url, { ...options, params })
            : axios.post(url, params, options);
        const scope = JSON.stringify([i18n.locale, store.state.token || '', store.state.ip || '', config.headers || {}]);
        const request = () => read({ method, url, params, scope, config }, fetch);
        return method === 'get' || publicRead ? trackPageRead(request) : fetch();
    }
}
